interface DataTagProps {
  tag: string | undefined;
}

const DataTag: React.FC<DataTagProps> = ({ tag }: DataTagProps) => {
  return (
    <p className='text-text-secondary hidden sm:inline-block'>
      <span>{tag}</span>
    </p>
  );
};

export default DataTag;
